module.exports = __webpack_public_path__ + "2acb60f2/img/arrow-share-icon.00a12c29.svg";